import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import AuthContext from '../contexts/auth';

import AuthLayout from '../pages/_layouts/auth';
import Default from '../pages/_layouts/default';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const { signed, user } = useContext(AuthContext);

  if (!signed && !user && isPrivate) {
    return <Redirect to="/" />;
  }

  if(user && signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  const Layout = signed ? Default : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
